import { useTranslation } from "react-i18next";
import AppLoader from "../../components/Loaders/AppLoader";
import { usePreferenceQuery } from "../Settings/Configuration/api/usePreferenceQuery";

function ConfigurationLoader({ children }) {
    const { t } = useTranslation();
    const { isLoading } = usePreferenceQuery();

    if (isLoading) {
        return (
            <AppLoader>
                {t("loading-configuration")}
            </AppLoader>
        );
    }

    return children;
}

export default ConfigurationLoader;
